module.exports = __webpack_public_path__ + "static/media/creative-commons-nc.bfd94f94.svg";